import { render } from "./AuxiliaryCards.vue?vue&type=template&id=5e922bde&scoped=true"
import script from "./AuxiliaryCards.vue?vue&type=script&lang=js"
export * from "./AuxiliaryCards.vue?vue&type=script&lang=js"

import "./AuxiliaryCards.vue?vue&type=style&index=0&id=5e922bde&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e922bde"]])

export default __exports__